import {SET_POST_SUSPENDED, POST_MESSAGE, CLEAR_MESSAGES} from './FrameActions'

const initialState = {
    postSuspended: false,
    messages: [],
    reducer: frame,
};

export default function frame(state = initialState, action = {}) {
    switch (action.type) {
        case SET_POST_SUSPENDED:
            return {
                ...state,
                postSuspended: action.suspended,
            };
        case POST_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, action.message]
            };
        case CLEAR_MESSAGES: {
            return {
                ...state,
                messages: [],
            };
        }
        default:
            return state;
    }
}
